import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { profileInformationSchema } from 'public/components/default_template/online_ordering/account/form-helpers'

type ProfileFormData = {
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  phone?: string | null
}

export const useEditAccountForm = (contact: any) => {
  const formMethods = useForm<ProfileFormData>({
    mode: 'onChange',
    resolver: yupResolver<{
      firstName?: string | null
      lastName?: string | null
      email?: string | null
      phone?: string | null
    }>(profileInformationSchema)
  })

  // Sync form with loaded contact data
  useEffect(() => {
    if (contact) {
      formMethods.reset({
        firstName: contact.firstName,
        lastName: contact.lastName,
        email: contact.email,
        phone: contact.phone
      })
    }
  }, [contact, formMethods])

  return formMethods
}
